import AnyFormat from "./any-format.js";

const isArray = obj => {
    return Array.isArray(obj);
};

const isObject = obj => {
    return obj != null && "object" == typeof obj && !isArray(obj);
};

const parse = obj => {
    // 如果是日期字符串
    if (AnyFormat.isDateString(obj)) {
        return AnyFormat.parseDate(obj);
    }
    // 如果是Dayjs日期对象，返回
    if (AnyFormat.isDate(obj, true)) {
        return obj;
    }
    
    // 递归处理
    if (isObject(obj)) {
        for(let item in obj) {
            obj[item] = parse(obj[item]);
        }
    } else if (isArray(obj)) {
        for(let i=0; i<obj.length; i++) {
            obj[i] = parse(obj[i]);
        }
    }
    
    return obj;
};

const format = obj => {
    if (AnyFormat.isDate(obj)) {
        return AnyFormat.format(obj);
    }
    
    if (isObject(obj)) {
        for(let item in obj) {
            obj[item] = format(obj[item]);
        }
    } else if (isArray(obj)) {
        for(let i=0; i<obj.length; i++) {
            obj[i] = format(obj[i]);
        }
    }
    
    return obj;
};
    
const JsonAutoDate = {
    parse,
    format,
    isArray,
    isObject
};

export default JsonAutoDate;